import { render } from "./Split.vue?vue&type=template&id=032bd1ba"
import script from "./Split.vue?vue&type=script&lang=js"
export * from "./Split.vue?vue&type=script&lang=js"

import "./Split.vue?vue&type=style&index=0&id=032bd1ba&lang=css"
script.render = render

export default script